export function createVideoPlayer() {
    require('videojs');
}



// WEBPACK FOOTER //
// ./js/common/utils/video.js